// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("images/checkmark_deepSeaGreen.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PaymentScheduleSettings,
.DownPaymentSettings {
  margin: 24px !important;
  position: relative;
  width: calc(100% - 40px);
}
.PaymentScheduleSettings-label,
.DownPaymentSettings-label {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
      -ms-flex-flow: row nowrap;
          flex-flow: row nowrap;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
.PaymentScheduleSettings-label__star,
.DownPaymentSettings-label__star {
  width: 1.2em;
}
.PaymentScheduleSettings .CheckBox,
.DownPaymentSettings .CheckBox {
  margin-top: 0 !important;
}
.PaymentScheduleSettings .CheckBox .check,
.DownPaymentSettings .CheckBox .check {
  border-radius: 2px;
  margin-top: 0 !important;
}
.PaymentScheduleSettings .CheckBox .check.checked,
.DownPaymentSettings .CheckBox .check.checked {
  background: #01FF94 url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  border: 1px solid #01FF94;
  background-size: 8px 6px;
  background-repeat: no-repeat;
  background-position: 2px 3px;
}
.PaymentScheduleSettings .CheckBox .Label,
.DownPaymentSettings .CheckBox .Label {
  display: inline !important;
  line-height: 18px !important;
  color: #002E33 !important;
}
.PaymentScheduleSettings-paymentScheduleType .radio,
.DownPaymentSettings-paymentScheduleType .radio {
  margin-bottom: 8px;
}
.PaymentScheduleSettings-paymentScheduleType .radio label,
.DownPaymentSettings-paymentScheduleType .radio label {
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/client/components/invoiceEditor/PaymentScheduleSettings/PaymentScheduleSettings.scss"],"names":[],"mappings":"AAAA;;EAIE,uBAAA;EACA,kBAAA;EACA,wBAAA;AADF;AAGE;;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,8BAAA;EAAA,6BAAA;MAAA,yBAAA;UAAA,qBAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,8BAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;AAAJ;AAEI;;EACE,YAAA;AACN;AAGE;;EACE,wBAAA;AAAJ;AAEI;;EACE,kBAAA;EACA,wBAAA;AACN;AACM;;EACE,2DAAA;EACA,yBAAA;EACA,wBAAA;EACA,4BAAA;EACA,4BAAA;AAER;AAEI;;EACE,0BAAA;EACA,4BAAA;EACA,yBAAA;AACN;AAII;;EACE,kBAAA;AADN;AAGM;;EACE,gBAAA;AAAR","sourcesContent":[".PaymentScheduleSettings,\n.DownPaymentSettings {\n  @import \"../../../Global/Colors\";\n\n  margin: 24px !important;\n  position: relative;\n  width: calc(100% - 40px);\n\n  &-label {\n    display: flex;\n    flex-flow: row nowrap;\n    justify-content: space-between;\n    align-items: center;\n\n    &__star {\n      width: 1.2em;\n    }\n  }\n\n  .CheckBox {\n    margin-top: 0 !important;\n\n    .check {\n      border-radius: 2px;\n      margin-top: 0 !important;\n\n      &.checked {\n        background: $ElectricGreen url(\"~images/checkmark_deepSeaGreen.svg\");\n        border: 1px solid $ElectricGreen;\n        background-size: 8px 6px;\n        background-repeat: no-repeat;\n        background-position: 2px 3px;\n      }\n    }\n\n    .Label {\n      display: inline !important;\n      line-height: 18px !important;\n      color: $DeepSeaGreen !important;\n    }\n  }\n\n  &-paymentScheduleType {\n    .radio {\n      margin-bottom: 8px;\n\n      label {\n        font-weight: 500;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
